/*
  Les quatre étapes de l'inscription à une journée pédagogique (VALIDÉ
  ÉCLOSION, 24/10/2026) : l'école, les enfants, les journées, puis le
  récapitulatif et le paiement.
*/

export type EtapeDuParcours = 'ecole' | 'enfants' | 'journees' | 'recapitulatif';

export const ETAPES_DU_PARCOURS: { cle: EtapeDuParcours; libelle: string; titre: string }[] = [
  { cle: 'ecole', libelle: 'École', titre: 'l’école' },
  { cle: 'enfants', libelle: 'Enfants', titre: 'les enfants' },
  { cle: 'journees', libelle: 'Journées', titre: 'les journées' },
  { cle: 'recapitulatif', libelle: 'Paiement', titre: 'le récapitulatif et le paiement' },
];
